module.exports = __webpack_public_path__ + "media/images/favicon-26fb604c0ddaea16010711b825f3a061.ico";